import { RefBusinessLists } from './../../../models/refBusinessLists.model';
import { Customer } from './../../../models/customer.model';
import { CustomerService } from './../../../services/customer/customer.service';
import { ColorPicker } from '../../../models/colorPicker.model';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerPageDataService } from '../../../services/customerPageData/customerPageData.service';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { CustomerPageDatas } from '../../../models/customerPageDatas.model';
import { ComponentType } from '../../../shared/enums/component-type/component-type.module';
import { InputType } from '../../../shared/enums/input-type/input-type.module';
import { SelectType } from '../../../shared/enums/select-type/select-type.module';
import { Page } from '../../../models/page.model';
import { FileData } from '../../../models/fileData.model';
import { Schedule } from '../../../models/schedule.model';
import { UtilsService } from '../../../services/shared/utils/utils.service';
import { Block } from '../../../models/block.model';
import { RoleType } from '../../../shared/enums/role-type/role-type.module';
import { LocalStorageService } from '../../../services/shared/local-storage/local-storage.service';
import { AuthService } from '../../../services/auth/auth.service';
import { CustomerPage } from '../../../models/customerPage.model';
import { CustomerPageData } from '../../../models/customerPageData.model';
import { CompletionStatus } from '../../../shared/enums/completion-status/completion-status.module';
import { BlockFormComponent } from './block-form/block-form.component';
import { GeneralParameterService } from '../../../services/generalparameter/generalparameter.service';
import { GeneralParameter } from '../../../models/generalParameter.model';
import { InstructionStep } from '../../../models/instructionStep.model';
import { InstructionsModalComponent } from '../../../shared/components/instructions-modal/instructions-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { PageType } from '../../../shared/enums/page-type/page-type.module';
import { OfferStatus } from '../../../shared/enums/offer-status/offer-status.module';
import { TooltipPosition } from '../../../models/tooltipPosition.model';
import { MatSidenav } from '@angular/material/sidenav';
import { CommonService } from '../../../services/shared/common/common.service';
import { finalize, forkJoin, Observable, Subject, switchMap, takeUntil } from 'rxjs';
import { SummaryModalComponent } from '../../../shared/components/summary-modal/summary-modal.component';
import { Title } from '@angular/platform-browser';
import { ContentAddress } from '../../../models/contentAddress.model';
import { ContentIntitule } from '../../../models/contentIntitule.model';
import { ContentUrl } from '../../../models/contentUrl.model';
import { ConnectionDefinition } from '../../../models/connectionDefinition.model';
import { ConnectionDefinitionService } from '../../../services/connectionDefinition/connection-definition.service';
import { PagesListComponent } from './pages-list/pages-list.component';
import { ContentActivityPrestations } from '../../../models/contentActivityPrestations.model';
import { PageService } from '../../../services/page/page.service';
import { LoadingService } from '../../../services/loading/loading.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { AppStateService } from '../../../services/shared/app-state/app-state.service';

@Component({
  selector: 'app-page-form',
  templateUrl: './page-form.component.html',
  styleUrl: './page-form.component.css',
  animations: [
    trigger('headerReadonly', [
      transition(':enter', [
        style({ height: '0', opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-out',
          style({ height: '45px', opacity: 1, transform: 'translateY(0)' })
        )
      ]),
      transition(':leave', [
        animate('250ms ease-in',
          style({ height: '0', opacity: 0, transform: 'translateY(-10px)' })
        )
      ])
    ])
  ]
})
export class PageFormComponent implements OnInit, OnDestroy, OnChanges, AfterViewChecked {
  private destroy$ = new Subject<void>();

  @Input() customerId: string | undefined;
  @Input() pageId: string | undefined;
  @ViewChildren('carouselBlock') carouselBlocks!: QueryList<ElementRef>;
  @ViewChild('carousel') carousel!: ElementRef;
  @ViewChild('mainContent', { static: false }) mainContent!: ElementRef;
  @ViewChild('headerCarousel') headerCarousel!: ElementRef;
  @ViewChild('footerCarousel') footerCarousel!: ElementRef;
  @ViewChild('footerCarouselParent') footerCarouselParent!: ElementRef;
  @ViewChild('cdcBlockError') cdcBlockErrorCarousel!: ElementRef;
  @ViewChild('cdcLink') cdcLinkCarousel!: ElementRef;
  @ViewChild('slideContent') slideContent!: ElementRef;
  @ViewChild('pagesMobileMenu') pagesMobileMenu!: MatSidenav;
  @ViewChild('pagesList') pagesListComponent!: PagesListComponent;

  constructor(private router: Router, private route: ActivatedRoute,
    private customerPageDataService: CustomerPageDataService, private customerService: CustomerService,
    private snackBar: SnackbarService, public translationService: TranslationService, private utils: UtilsService,
    private lStorage: LocalStorageService, public authService: AuthService, private generalParameterService: GeneralParameterService,
    private dialogMat: MatDialog, private common: CommonService,
    private connectionDefinitionService: ConnectionDefinitionService,
    private titleService: Title,
    private elRef: ElementRef,
    private pageService: PageService,
    private loadingService: LoadingService,
    private appState: AppStateService) { }
  pageKeys: CustomerPage[] = [];
  customer!: Customer;
  role!: RoleType[];
  pagesMap: Map<CustomerPage, CustomerPage[]> = new Map<CustomerPage, CustomerPage[]>();
  currentStep: number = 0;
  currentBlockId: string | null = null;
  currentBlockIteration: number | undefined = undefined;
  activeDone: boolean = false;
  sso: string = '';

  customerPage!: CustomerPage;
  customerPageDatas!: CustomerPageData[];
  summaryBlocks!: Block[];
  originPage!: Page;

  refBusinessLists: RefBusinessLists = {activities:[], certifications:[], hours:[], countries:[], urlTypes:[]}

  ComponentType = ComponentType;
  InputType = InputType;
  SelectType = SelectType;
  OfferStatus = OfferStatus;

  weightPercentage: number = 100;
  carouselHeight: number = 100;

  incompletePages: CustomerPage[] = [];


  isAllRequiredFilled: boolean = true;

  isPreview: boolean = false;
  userRole: RoleType = RoleType.INTERN;

  instructionSteps: InstructionStep[] = [];
  hasFetchedInstructionSteps = false;

  offerStatus!: OfferStatus;
  offerHidden: boolean = false;

  isDesktop = true;

  hasUnfinishedPages = false;

  CompletionStatus = CompletionStatus;

  fullConnectionsDefinitions: ConnectionDefinition[] = [];

  pageGuide: string | undefined;
  blockGuide: string | undefined;

  currentYear: number = new Date().getFullYear();

  RoleType = RoleType;

  isEditable?: boolean;
  isOfferReadOnly: boolean = false;
  isEmbed: boolean = false;
  isSubmittable: boolean = true;
  @ViewChild('htmlWrapper')
  set htmlWrapper(ref: ElementRef<HTMLElement>) {
    if (!ref) return;
    if (!this.isAndroidOrWindows()) {
      ref.nativeElement.addEventListener(
        'click',
        this.onHtmlClick,
        true
      );
    }
  }
  ngOnInit() {
    this.isEmbed = this.appState.getIsEmbed();

    this.loadingService.show();
    this.router.navigate([], {
      queryParams: {
        'sso': null
      },
      queryParamsHandling: 'merge'
    })

    this.route.paramMap.subscribe(params => {
      this.currentStep = 0;
      this.customerId = params.get('customerId')!;
      this.pageId = params.get('pageId')!;

      this.isPreview = this.appState.getIsPreview();

      //make url if sso to use on left-nav-bar
      this.sso = this.authService.getSSO();

      //get user roles
      this.authService.loadUserRole()
      this.authService.getUserRoleNotAsync().subscribe(role => {
        if (role !== null) {
          this.userRole = role;
        }

        const rawTitle = this.route.snapshot.data['title'];
        if(this.userRole != RoleType.CUSTOMER && this.customerId)
        {
          this.titleService.setTitle(`${this.customerId} - ${rawTitle}`);
        }
        else{
          this.titleService.setTitle(`${rawTitle}`);
        }
      });

      this.getConnectionsDefinitions();

      this.loadingService.show();
      this.customerPageDataService.getRefBusinessLists()
      .subscribe({
        next: (lists: RefBusinessLists) => {
          this.refBusinessLists = lists;
          this.loadingService.hide();
          //preview or customer
          if (this.isPreview) {
            this.route.queryParams.subscribe(queryParams => {
              var roleType = queryParams['role'];
              const roleStorageKey = `preview_${this.pageId}_${roleType}`;
              const existingPage = this.lStorage.getItemWithExpiry(roleStorageKey);
              if (existingPage) {
                this.customerPage = existingPage.page;
                this.customerPageDatas = existingPage.customerPageDatas;
                this.updateCurrentBlockId();
                this.getSummaryBlocks();
                this.customer = existingPage.customer;
                this.arrangePages(this.customer);
                this.userRole = existingPage.role;
                this.isSubmittable = this.customerPage.roles?.find(x => x.name === this.userRole)?.accessibility.submittable ?? (this.userRole == RoleType.INTERN ? false : true);
                this.loadingService.hide();
                this.getInstructionSteps();
                //recalculate (backend gives wrong calculate when build, because data is not yet filtered by role)
                this.handleCustomerPageDatasChange(this.customerPageDatas);
                this.handleAllPageBlocksStats();
                this.getOriginPage();
              }
              else {
                this.router.navigate(['']);
                this.snackBar.showError(this.translationService.translate('Error fetching page'));
                this.loadingService.hide();
              }
            });
          }
          else {
            this.loadAllData();
          }
        },
        error: (error) => {
          this.snackBar.showError(this.translationService.translate('Error on fetching refBusiness lists'));
          this.loadingService.hide();
        }
      });
    });

    this.isDesktop = this.utils.isDesktop();
    setTimeout(() => {
      if(this.isPreview)
      {
        this.route.queryParams.subscribe(params => {
          const roleId = Number(params['role']);
          const roleName = RoleType[roleId] || 'Unknown';
          const roleNameTranslated = this.translationService.translate(roleName);
          const newTitle = roleNameTranslated ? `Preview - ${roleNameTranslated}` : 'Preview';
          this.titleService.setTitle(newTitle);
        });
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private _blocksForm!: QueryList<BlockFormComponent>;
  @ViewChildren(BlockFormComponent)
  set blocksForm(content: QueryList<BlockFormComponent>) {
    this._blocksForm = content;

    if (content && content.length > 0) {
      Promise.resolve().then(() => {
        this.calculateGlobalEditable(content);
        this.carouselAnimation(); //init
      });
    }
  }
  get blocksForm(): QueryList<BlockFormComponent> {
    return this._blocksForm;
  }

  getStoredPage(pageId: string, roleType: RoleType): any | null {
    const roleStorageKey = `preview_${pageId}_${roleType}`;
    const storedData = localStorage.getItem(roleStorageKey);

    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const currentTime = new Date();

      if (currentTime < parsedData.expirationDate) {
        return parsedData;
      } else {
        localStorage.removeItem(roleStorageKey);
      }
    }

    return null;
  }

  listenerAttached = false;
  ngAfterViewChecked() {
    if (!this.listenerAttached) {
      const guideContent = this.elRef.nativeElement.querySelector('.page-guide-content');
      if (guideContent) {
        guideContent.addEventListener('wheel', (event: WheelEvent) => {
          this.utils.preventScrollOutside(event, guideContent);
        });
        this.listenerAttached = true;
      }
    }
  }

  carouselAnimation() {
    this.adjustBlockContainerHeight();
    this.adjustContainer();
    if (this.carouselBlocks && this.carouselBlocks.length > 0) {
      let activeIndex = -1;
      this.activeDone = false;

      // Find the index of the element with the 'activeItem' class
      this.carouselBlocks.forEach((carouselBlock, i) => {
        if (carouselBlock.nativeElement.classList.contains('activeItem')) {
          const blockId = carouselBlock.nativeElement.getAttribute('data-blockid');
          const blockIteration = carouselBlock.nativeElement.getAttribute('data-blockiteration');
          document.querySelectorAll('.sidenav-section-2 .itemMenuBlock').forEach(el => {
            el.classList.remove('block-selected');
          });

          const targets = document.querySelectorAll<HTMLElement>(`.sidenav-section-2 .itemMenuBlock[data-blockid="${blockId}"][data-blockiteration="${blockIteration}"]`);
          targets.forEach(target => {
            target.classList.add("block-selected");
          });

          activeIndex = i;
          if (carouselBlock.nativeElement.classList.contains('doneItem')) {
            this.activeDone = true;
            if (!this.isEmbed) {
              this.calculateIncompletePages();
            }
          }
        }
      });

      if(this.isDesktop){
        var offset = 0;
        var maxStep = 2;
        this.carouselBlocks.forEach((carouselBlock, i) => {
          const nativeElement = carouselBlock.nativeElement;
          nativeElement.style.removeProperty('max-height');
          nativeElement.style.removeProperty('opacity');
          nativeElement.style.removeProperty('transition');
          nativeElement.style.removeProperty('left');
          nativeElement.style.removeProperty('transform');
          nativeElement.style.removeProperty('z-index');
          nativeElement.style.removeProperty('display');
          var slideContentElement = nativeElement.querySelector('.slideContent');
          if (slideContentElement) {
            slideContentElement.style.removeProperty('max-height');
          }
          if (i === activeIndex) {
            // The current element is the activeItem, so it should be visible
            nativeElement.style.setProperty('transition', 'left 0.2s ease-in-out', 'important');
            nativeElement.style.setProperty('opacity', '1', 'important');
            nativeElement.style.setProperty('z-index', '100', 'important');
            nativeElement.style.setProperty('transform', 'translate(0px, 0px)', 'important');
          }
          else if (nativeElement.classList.contains('nextItem') && nativeElement.classList.contains('doneItem') && !this.activeDone) {
            nativeElement.style.setProperty('display', 'none');
          }
          else if (i === activeIndex + 1 && !this.activeDone) {
            // The current element is the nextItem, so it should be visible
            nativeElement.style.setProperty('transition', 'opacity 0.5s ease-in-out, left 0.2s ease-in-out', 'important');
            nativeElement.style.setProperty('opacity', '1', 'important');
            nativeElement.style.setProperty('left', '100%', 'important');
            nativeElement.style.setProperty('transform', 'translateX(10%)', 'important');
            nativeElement.style.setProperty('z-index', '100', 'important');
            nativeElement.style.setProperty('display', 'block');
          } else if (i < activeIndex && !this.activeDone) {
            // The three elements before the activeItem
            if (i < maxStep) {
              var step = (activeIndex < maxStep ? activeIndex : maxStep);
              offset = ((step +1) - (i + 1)) * 5
              nativeElement.style.setProperty('opacity', '1', 'important');
              nativeElement.style.setProperty('transition', 'opacity 0.2s ease-in-out, left 0.2s ease-in-out, transform 0.2s ease-in-out', 'important');
              nativeElement.style.setProperty('transform', `translate(-${offset}px, ${offset}px)`, 'important');
              nativeElement.style.setProperty('z-index', `${i + 1}`, 'important');
            } else {
              nativeElement.style.setProperty('opacity', '0', 'important');
            }

          } else if (nativeElement.classList.contains('previousItem') || nativeElement.classList.contains('nextItem')) {
            // All other elements should be hidden
            nativeElement.style.setProperty('transition', 'opacity 0.5s ease-in-out, left 0.2s ease-in-out', 'important');
            nativeElement.style.setProperty('opacity', '0', 'important');
            nativeElement.style.setProperty('left', '100%', 'important');
            nativeElement.style.setProperty('transform', 'translateX(10%)', 'important');
            nativeElement.style.setProperty('z-index', `-${activeIndex - i + 1}`, 'important');
            nativeElement.style.setProperty('display', 'block');
          }
        });
      } else{

        this.carouselBlocks.forEach((carouselBlock, i) => {
          const block = carouselBlock.nativeElement;
          block.style.removeProperty('opacity');
          block.style.removeProperty('transition');
          block.style.removeProperty('left');
          block.style.removeProperty('transform');
          block.style.removeProperty('z-index');
          block.style.removeProperty('display');
          var slideContentElement = block.querySelector('.slideContent');
          if (slideContentElement) {
            slideContentElement.style.removeProperty('max-height');
          }

          if(block.classList.contains('activeItem')){
            block.style.setProperty('opacity', '1', 'important');
            block.style.setProperty('transform', 'translateX(0)', 'important');

          } else if(block.classList.contains('previousItem')){
            block.style.setProperty('opacity', '0', 'important');
            block.style.setProperty('transform', 'translateX(-100%)', 'important');
            var slideContentElement = block.querySelector('.slideContent');
            if (slideContentElement) {
              slideContentElement.style.setProperty('max-height', this.carouselHeight.toString() + 'px','important');
            }
      } else if(block.classList.contains('nextItem')){
            block.style.setProperty('opacity', '0', 'important');
            block.style.setProperty('transform', 'translateX(100%)', 'important');
            var slideContentElement = block.querySelector('.slideContent');
            if (slideContentElement) {
              slideContentElement.style.setProperty('max-height', this.carouselHeight.toString() + 'px','important');
            }
      }
        });
      }

    }
  }
  calculateIncompletePages() {
    var incompletePages: CustomerPage[] = [];
    this.pagesMap.forEach((pages, parentPage) => {
      var percentage = this.fetchPageStats(parentPage.id!);
      if (parentPage.id !== undefined && parentPage.id !== null && (percentage === undefined || percentage! < 100)) {
        parentPage.completionPercent = percentage;
        incompletePages.push(parentPage);
      }
      pages.forEach(childPage => {
        var percentage = this.fetchPageStats(childPage.id!);
        if (percentage === undefined || percentage! < 100) {
          childPage.completionPercent = percentage;
          incompletePages.push(childPage);
        }
      });
    });

    this.incompletePages = incompletePages.filter(p => p.id != this.pageId);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    this.carouselAnimation();

    //fix error tooltips position
    if (this.currentBlockId) {
      var blockFormComponent = this.blocksForm.find(x => x.block.id == this.currentBlockId && x.block.iteration == this.currentBlockIteration && x.tooltipData.some(y=> y.show));
      if (blockFormComponent) {
        blockFormComponent.runEvaluateAllComponents(true);
      }

      //Fix Menu Step Stat
      this.handleAllPageBlocksStats();
    }

    this.isDesktop = this.utils.isDesktop();
  }


  adjustContainer() {
    // Adjust the height of the sidenav container
    var sidenav_container = document.querySelector('.customer-container') as HTMLElement;
    if (sidenav_container) {
      if (this.utils.isDesktop()) {
        const zoom = this.utils.getRootZoom();
        const bodyElement = document.querySelector('body') as HTMLElement;
        const headerElement = document.querySelector('.header-desktop') as HTMLElement;
        const headerReadonlyElement = document.querySelector('.header-readonly') as HTMLElement;
        const bodyHeight = bodyElement.offsetHeight;
        const headerHeight = this.utils.getTotalHeight(headerElement);
        const headerReadonlyHeight = this.utils.getTotalHeight(headerReadonlyElement);
        sidenav_container.style.setProperty('height', `${(bodyHeight / zoom) - (headerHeight + headerReadonlyHeight)}px`);
      } else {
        sidenav_container.style.removeProperty('height');
      }
    }
  }

  adjustBlockContainerHeight() {
    if (this.carousel !== null && this.carousel !== undefined && this.isDesktop) {
      const zoom = this.utils.getRootZoom();
      //Adjust Block
      const bodyElement = document.querySelector('body') as HTMLElement;
      const headerElement = document.querySelector('.header-desktop') as HTMLElement;
      const headerReadonlyElement = document.querySelector('.header-readonly') as HTMLElement;
      const headerCarouselElement = this.headerCarousel ? this.headerCarousel.nativeElement as HTMLElement : null;
      const footerCarouselElement = this.footerCarousel.nativeElement as HTMLElement;

      this.carousel.nativeElement!.style.removeProperty('min-height');
      this.carousel.nativeElement!.style.removeProperty('height');

      const bodyHeight = bodyElement.offsetHeight;
      const headerHeight = this.utils.getTotalHeight(headerElement);
      const headerReadonlyHeight = headerReadonlyElement ? this.utils.getTotalHeight(headerReadonlyElement) : 0;
      const headerCarouselHeight = this.utils.getTotalHeight(headerCarouselElement);
      const footerCarouselHeight = this.utils.getTotalHeight(footerCarouselElement); /*+ this.utils.getTotalHeight(blockErrorCarouselElement) + this.utils.getTotalHeight(linkCarouselElement);*/
      this.footerCarouselParent.nativeElement.style.height = footerCarouselHeight + 'px';

      const availableHeight = (bodyHeight / zoom) - headerHeight - headerReadonlyHeight - headerCarouselHeight - footerCarouselHeight;

      this.carouselBlocks.forEach((carouselBlock, i) => {
        const el = carouselBlock.nativeElement;
        el.style.height = availableHeight + 'px';

        const slideContent = el.querySelector('.slideContent');
        const slideTitle = el.querySelector('.slideTitle');

        if (slideContent) {
          let availableSlideHeight;
          let titleHeight = this.utils.getTotalHeight(slideTitle);
          if (el.classList.contains('doneItem') && slideContent.classList.contains('completed')) {
            availableSlideHeight = availableHeight - titleHeight - 15;
          } else {
            availableSlideHeight = availableHeight - titleHeight - 25;
          }

          slideContent.style.height = availableSlideHeight + 'px';
        }
      });
      this.carousel.nativeElement.style.height = availableHeight + 'px';

    }
    else if (this.carousel !== null && this.carousel !== undefined) {
      const headerElement = document.querySelector('header.header-mobile .column-2') as HTMLElement;
      const headerReadonlyElement = document.querySelector('.header-readonly') as HTMLElement;
      const mainContentElement = document.querySelector('.mainContent') as HTMLElement;

      if (mainContentElement) {
        var headerHeight = this.utils.getTotalHeight(headerElement);
        var headerReadonlyHeight = headerReadonlyElement ? this.utils.getTotalHeight(headerReadonlyElement) : 0;
        var contentHeight = document.documentElement.clientHeight - headerHeight - headerReadonlyHeight;
        mainContentElement.style.setProperty('height', contentHeight.toString() + 'px', 'important');
      }

      this.footerCarouselParent.nativeElement!.style.removeProperty('height');
      this.carouselBlocks.forEach((carouselBlock, i) => {
        const _carouselBlock = carouselBlock.nativeElement;
        _carouselBlock!.style.removeProperty('height');
        var slideContentElement = _carouselBlock.querySelector('.slideContent');
        if (slideContentElement) {
          slideContentElement.style.removeProperty('height');
        }
      });
    }
  }

  getSummaryBlocks() {
    const clonedBlocks = JSON.parse(JSON.stringify(this.customerPage.blocks));
    this.summaryBlocks = clonedBlocks;
  }

  calculateBlockKeyIndicator(blockId: string, blockIteration: number) {
    if (!this.customerPage || !this.customerPage.blocks) {
      return 0;
    }

    var block = this.customerPage.blocks.find(x => x.id == blockId && x.iteration == blockIteration);
    var blockComponents = block?.componentGroups.flatMap(x => x.components).flatMap(x => x.id);

    if (block) {
      var componentsConditionedHiddenIds: string[] = [];

      const totalWeight = block.componentGroups.reduce((groupSum, group) => {
        const componentWeightSum = group.components.reduce((componentSum, component) => {

          //not include component conditioned closed hidden
          const componentElement = document.querySelector(
            `.cdc-carousel-block:not(.cdc-summary) .summary-edit-area[data-component-id="${component.id}"]`
          ) as HTMLElement;
          if (!componentElement) {
            componentsConditionedHiddenIds.push(component.id)
            return componentSum;
          }

          const weight = component.keyIndicator?.weight;
          return componentSum + (weight !== null && weight !== undefined ? +weight : 0);
        }, 0);
        return groupSum + componentWeightSum;
      }, 0);

      const processedComponents = new Set<string>();
      let filledWeight = 0;

      //not include component conditioned closed hidden
      var customerPageDatasNotHidden = this.customerPageDatas.filter(x => blockComponents?.includes(x.component.id) && x.blockIteration == this.currentBlockIteration && !componentsConditionedHiddenIds.includes(x.component.id));
      customerPageDatasNotHidden.forEach(data => {
        const componentId = data.component.id;

        if (processedComponents.has(componentId)) {
          return;
        }

        let isFilled = false;

        switch (data.component.type) {
          case ComponentType.INPUT:
            if (data.component.config?.inputType === InputType.FILE) {
              isFilled = this.utils.checkFileFilled(data.values as FileData[]);
            } else if (data.component.config?.inputType === InputType.COLOR_PICKER) {
              isFilled = this.utils.checkColorPickerFilled(data.values as ColorPicker[], data.component.config?.hasColorText!, 1);
            } else {
              isFilled = this.utils.checkInputOrSelectFilled(data.values as string[], 1);
            }
            break;
          case ComponentType.SELECT:
            isFilled = this.utils.checkInputOrSelectFilled(data.values as string[], 1);
            break;
          case ComponentType.SCHEDULE:
            isFilled = this.utils.checkScheduleFilled(data.values as Schedule[]);
            break;
          default:
            isFilled = true;
        }

        if (isFilled) {
          const foundComponent = this.customerPage.blocks!
            .filter(block => block.iteration == data.blockIteration)
            .flatMap(block => block.componentGroups)
            .flatMap(group => group.components)
            .find(component => component.id === componentId);

          const weight = foundComponent?.keyIndicator?.weight;
          filledWeight += (weight !== null && weight !== undefined ? +weight : 0);

          processedComponents.add(componentId);
        }
      });
      this.weightPercentage = totalWeight == 0 ? 100 : (filledWeight / totalWeight) * 100;
      return Math.round(this.weightPercentage);
    }

    return 0;
  }


  calculateKeyIndicatorWeight() {
    if (!this.customerPage || !this.customerPage.blocks) {
      return 0;
    }

    var componentsConditionedHiddenIds: string[] = [];

    const totalWeight = this.customerPage.blocks.reduce((blockSum, block) => {
      const groupWeightSum = block.componentGroups.reduce((groupSum, group) => {
        const componentWeightSum = group.components.reduce((componentSum, component) => {

          //not include component conditioned closed hidden
          const componentElement = document.querySelector(
            `.cdc-carousel-block:not(.cdc-summary) .summary-edit-area[data-component-id="${component.id}"]`
          ) as HTMLElement;
          if (!componentElement) {
            componentsConditionedHiddenIds.push(component.id)
            return componentSum;
          }

          const weight = component.keyIndicator?.weight;
          return componentSum + (weight !== null && weight !== undefined ? +weight : 0);
        }, 0);
        return groupSum + componentWeightSum;
      }, 0);
      return blockSum + groupWeightSum;
    }, 0);

    const processedComponents = new Set<string>();
    let filledWeight = 0;

    //not include component conditioned closed hidden
    var customerPageDatasNotHidden = this.customerPageDatas.filter(x => !componentsConditionedHiddenIds.includes(x.component.id));
    customerPageDatasNotHidden.forEach(data => {
      const componentId = data.component.id;

      if (processedComponents.has(componentId)) {
        return;
      }

      let isFilled = false;

      switch (data.component.type) {
        case ComponentType.INPUT:
          if (data.component.config?.inputType === InputType.FILE) {
            isFilled = this.utils.checkFileFilled(data.values as FileData[]);
          } else if (data.component.config?.inputType === InputType.COLOR_PICKER) {
            isFilled = this.utils.checkColorPickerFilled(data.values as ColorPicker[], data.component.config?.hasColorText!, 1);
          } else {
            isFilled = this.utils.checkInputOrSelectFilled(data.values as string[], 1);
          }
          break;
        case ComponentType.SELECT:
          isFilled = this.utils.checkInputOrSelectFilled(data.values as string[], 1);
          break;
        case ComponentType.SCHEDULE:
          isFilled = this.utils.checkScheduleFilled(data.values as Schedule[]);
          break;
        case ComponentType.ADDRESS:
          isFilled = this.utils.checkAddressFilled(data.values as ContentAddress[]);
          break;
        case ComponentType.INTITULE:
          isFilled = this.utils.checkIntituleFilled(data.values as ContentIntitule[]);
          break;
        case ComponentType.URL:
          var urlTypes = this.refBusinessLists.urlTypes ?? [];
          isFilled = this.utils.checkUrlsWellFilled(data.values as ContentUrl[], urlTypes);
          break;
        case ComponentType.VISUAL_PUBLICATION:
          isFilled = this.utils.checkVisualPublicationFilled(data.values as FileData[]);
          break;
        case ComponentType.ACTIVITY_PRESTATIONS:
          isFilled = this.utils.checkActivityPrestationsFilled(data.values as ContentActivityPrestations[]);
          break;
        default:
          isFilled = true;
      }

      if (isFilled) {
        const foundComponent = this.customerPage.blocks!
          .filter(block => block.iteration == data.blockIteration)
          .flatMap(block => block.componentGroups)
          .flatMap(group => group.components)
          .find(component => component.id === componentId);

        const weight = foundComponent?.keyIndicator?.weight;
        filledWeight += (weight !== null && weight !== undefined ? +weight : 0);

        processedComponents.add(componentId);
      }
    });

    this.weightPercentage = totalWeight == 0 ? 100 : (filledWeight / totalWeight) * 100;
    return Math.round(this.weightPercentage);
  }

  fetchPageStats(pageId: string): number | undefined {
    return this.common.fetchPageStats(this.customer.pages ?? [], pageId) ?? 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerId']?.isFirstChange() || changes['pageId']?.isFirstChange()) {
      return;
    }

    if (changes['customerId'] && !this.isPreview) {
      this.loadAllData();
    }
    else if (changes['pageId'] && !this.isPreview) {
      this.loadPageData();
    }
  }

  loadAllData()
  {
    if (!this.pageId || !this.customerId) {
      this.snackBar.showError(this.translationService.translate('ID is null'));
      return;
    }

    this.loadingService.show();
    forkJoin({
      pageData: this.fetchCustomerPageData(),
      customerData: this.fetchCustomerData()
    })
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loadingService.hide();
      })
    )
      .subscribe({
      next: (results) => {
        var currentCompletionPercent = results.pageData.customerPage.completionPercent;
        var currentPageOnCustomer = results.customerData.pages?.find(x => x.id == results.pageData.customerPage.id);
        if(currentPageOnCustomer){
          currentPageOnCustomer.completionPercent = currentCompletionPercent;
        }
        this.handlePageData(results.pageData);
        this.handleCustomerData(results.customerData);
        this.getOriginPage();
      },
      error: (error) => this.handleError(error)
    });
  }

  loadPageData(): void {
    if (!this.pageId || !this.customerId) {
      return;
    }

    this.loadingService.show();
    this.fetchCustomerPageData()
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loadingService.hide())
    )
    .subscribe({
      next: (pageData) => {
        this.handlePageData(pageData)
      },
      error: (error) => this.handleError(error)
    });
  }

  fetchCustomerPageData(): Observable<CustomerPageDatas> {
    return this.customerPageDataService.getCustomerPageDatas(this.pageId!, this.customerId!);
  }

  fetchCustomerData(): Observable<Customer> {
    return this.customerService.getCustomer(this.customerId!);
  }

  handlePageData(data: CustomerPageDatas): void {
    this.offerStatus = data.offerStatus;
    this.offerHidden = data.offerHidden;
    this.isOfferReadOnly = this.offerStatus != OfferStatus.OPEN && this.userRole != RoleType.ADMIN;
    if (this.userRole != RoleType.ADMIN && this.offerStatus == OfferStatus.CLOSED) {
      this.router.navigate(['']);
    }
    this.customerPage = data.customerPage;
    this.isSubmittable = this.customerPage.roles?.find(x => x.name === this.userRole)?.accessibility.submittable ?? (this.userRole == RoleType.INTERN ? false : true);
    this.customerPageDatas = data.customerPageDatas;
    this.updateCurrentBlockId();
    this.getSummaryBlocks();
    this.getInstructionSteps();
    this.handleAllPageBlocksStats();
  }

  handleCustomerData(data: Customer): void {
    this.customer = data;
    this.arrangePages(data);

    if (data.pages && data.pages.some(x => x.completionPercent == undefined || x.completionPercent < 100)) {
      this.hasUnfinishedPages = true;
    }
  }

  handleError(error: any): void {
    if (error.status == 404 || error.status == 400) {
      this.router.navigate(['']);
    }
    this.snackBar.showError(this.translationService.translate('Error fetching data'));
  }

  arrangePages(customer: Customer): void {
    const temp = new Map<CustomerPage, CustomerPage[]>();
    const parentIndex = new Map<string, CustomerPage>();
    var pages = customer.pages;
    if (pages && pages.length > 0) {
      const parentPages = this.common.orderPages(pages.filter(page => page.parentPage === undefined || page.parentPage === null));
      const childPages = this.common.orderPages(pages.filter(page => page.parentPage !== undefined && page.parentPage !== null));

      parentPages.forEach(parent => {
        temp.set(parent, []);
        parentIndex.set(parent.id!, parent);
      });

      childPages.forEach(child => {
        const parentPage = parentIndex.get(child.parentPage!.id!);
        if (parentPage) {
          const children = temp.get(parentPage);
          if (children) {
            children.push(child);
          } else {
            temp.set(parentPage, [child]);
          }
        }
        else {
          if (child.parentPage) {
            var parentNotInCustomer: CustomerPage = {
              title: child.parentPage.title
            }
            temp.set(parentNotInCustomer, []);
            const children = temp.get(parentNotInCustomer);
            if (children) {
              children.push(child);
            }
          }
        }
      });
    }

    this.pagesMap = temp;
    this.pageKeys = Array.from(temp.keys());
  }

  calculateGlobalEditable(blocks: QueryList<BlockFormComponent>) {
    var onlyExcludedComponentTypes = this.customerPage.blocks?.flatMap(b => b.componentGroups).flatMap(g => g.components).every(c => this.common.staticComponentTypes.includes(c.type!));
    this.isEditable = this.customerPage.blocks?.some(block =>
      block.componentGroups.some(group =>
        group.components.some(component =>
          this.common.isComponentEditable(component, this.offerStatus, this.fullConnectionsDefinitions, this.userRole, this.isPreview)
          || onlyExcludedComponentTypes
        )
      )
    );
  }

  blockHasErrors = false;
  nextStep(): void {
    //Send request for all fields to do evaluate
    if (this.currentBlockId && this.currentBlockIteration != undefined) {
      var blockFormComponent = this.blocksForm.find(x => x.block.id == this.currentBlockId && x.block.iteration == this.currentBlockIteration);
      if (blockFormComponent) {
        blockFormComponent.runEvaluateAllComponents(true);
        setTimeout(() => {

          var tooltipsError = blockFormComponent?.tooltipData.filter(tooltip => tooltip.show == true);
          if (!tooltipsError || tooltipsError.length == 0) {
            this.blockHasErrors = false;
            if (this.currentStep < this.customerPage.blocks!.length + 1) {
              this.currentStep++;
              this.updateCurrentBlockId();

              this.scrollToTopOnMobile();
            }
          }
          else {
            this.blockHasErrors = true;
            //scroll to first error field
            if(this.isDesktop)
            {
              blockFormComponent!.scrollToFirstTooltipError();
            }
            else{
              this.scrollToFirstTooltipError(tooltipsError);
            }
          }

        }, 0);
      }
    }
    else {
      //done
      this.blockHasErrors = false;
      if (this.currentStep < this.customerPage.blocks!.length + 1) {
        this.currentStep++;
        this.updateCurrentBlockId();

        //Close Menus
        const el = document.querySelector(
          '.mat-expansion-panel-header mat-panel-title div.title-panel-indicator .panel-close'
        ) as HTMLElement;
        el?.click();

        if ((this.customerPage.blocks!.length + 1) === this.currentStep && !this.isPreview) {
          //confirm done and not preview
          this.customerPage.completionStatus = CompletionStatus.COMPLETED;
          var pageCustomer = this.customer.pages?.find(x => x.id == this.customerPage.id);
          if (pageCustomer) {
            pageCustomer.completionStatus = this.customerPage.completionStatus;
          }
        }

        setTimeout(() => {
          this.carouselAnimation();
        }, 0);
      }
    }

  }

  previousStep(): void {
    if (this.currentStep > 0) {
      this.closeAllTooltipErrorsOnCurrentBlock();
      this.currentStep--;
      this.updateCurrentBlockId();
      this.scrollToTopOnMobile();
    }
  }

  findFirstInvalidBlock(index: number): number | undefined {
    var currentBlockIndex = this.currentStep;
    var blockErrorIndex = undefined;
    this.blocksForm.some((blockFormComponent, blockIndex) => {
      if (blockIndex >= currentBlockIndex && blockIndex <= index) {

        //if current block select, dont display error tooltips
        var displayErrors = blockIndex != index;
        const blockHasErrors = blockFormComponent.runEvaluateAllComponents(displayErrors);

        if (blockHasErrors) {
          blockErrorIndex = blockIndex;
          return true;
        }
      }
      return false;
    });
    return blockErrorIndex;
  }

  goToStep(index: number): void {
    if (index < this.currentStep) { //ANY PREVIOUS STEP
      this.closeAllTooltipErrorsOnCurrentBlock();
      this.currentStep = index;
      this.updateCurrentBlockId();
      this.scrollToTopOnMobile();
    } else if (index > this.currentStep) {
      var blockIndexError = this.findFirstInvalidBlock(index);
      if (blockIndexError == undefined) {
        if (this.currentStep < this.customerPage.blocks!.length + 1) {
          this.currentStep = index;
          this.updateCurrentBlockId();
          this.scrollToTopOnMobile();
        }
      } else {
        this.currentStep = blockIndexError;
        this.updateCurrentBlockId();

        if(index != this.currentStep)
        {
          var blockFormComponent = this.blocksForm.find(x => x.block.id == this.currentBlockId && x.block.iteration == this.currentBlockIteration && x.tooltipData.some(y => y.show));
          if (blockFormComponent) {
            blockFormComponent.runEvaluateAllComponents(true);
            setTimeout(() => {
              this.nextStep();
            }, 0);
          }
        }
      }
    }
  }

  updateCurrentBlockId() {
    if (this.customerPage && this.customerPage.blocks && this.customerPage.blocks[this.currentStep]) {
      this.currentBlockId = this.customerPage.blocks[this.currentStep].id;
      this.currentBlockIteration = this.customerPage.blocks[this.currentStep].iteration;
    }
    else if(this.customerPage && this.customerPage.blocks && this.currentStep == this.customerPage.blocks?.length) {
      //summary
      this.currentStep--;
      this.currentBlockId = this.customerPage.blocks[this.currentStep].id;
      this.currentBlockIteration = this.customerPage.blocks[this.currentStep].iteration;

      this.onOpenSummaryDialog();
    }
    else {
      this.currentBlockId = null;
      this.currentBlockIteration = undefined;
    }

    this.checkErrorsOnCurrentBlock();
    this.updateGuide();

    setTimeout(() => {
      this.carouselAnimation();
    }, 0);
  }

  checkFieldsFilled() {
    if (this.currentBlockId && this.currentBlockIteration != undefined) {
      var componentsIds = this.customerPage.blocks!
        .find(block => block.id === this.currentBlockId && block.iteration === this.currentBlockIteration)?.componentGroups
        .flatMap(group => group.components
          .filter(x => x.type != ComponentType.BUTTON && x.type != ComponentType.TEXT && x.type != ComponentType.TITLE && x.type != ComponentType.HTML && x.isRequired === true)
          .map(component => component.id));

      if (componentsIds && componentsIds?.length > 0) {

        componentsIds.forEach(componentId => {

          // component must obey the min of each group
          var group = this.customerPage.blocks!.find(block => block.id === this.currentBlockId && block.iteration === this.currentBlockIteration)?.componentGroups.find(group => group.components.find(x => x.id === componentId));
          var component = this.customerPage.blocks!.find(block => block.id === this.currentBlockId && block.iteration === this.currentBlockIteration)?.componentGroups.flatMap(group => group.components).find(x => x.id === componentId);

          var min = group!.multipleConfig?.minQuantity;
          var customerPageDatas = this.filteredCustomerPageDatas(this.customerPageDatas.filter(data => data.component.id === componentId), component?.multipleConfig?.minQuantity, component?.regex); //only customerPageDatas filled from differente dataGroups

          if (min! > customerPageDatas.length) {
            this.isAllRequiredFilled = false;
          }
          else {
            this.isAllRequiredFilled = true;
          }
        });
      }
      else {
        this.isAllRequiredFilled = true;
      }
    }
  }

  filteredCustomerPageDatas(customerPageDatas: CustomerPageData[], minQuantity?: number, regex?: string): CustomerPageData[] {
    return customerPageDatas.filter(data => {
      let isFilled = false;

      switch (data.component.type) {
        case ComponentType.INPUT:
          if (data.component.config?.inputType === InputType.FILE) {
            isFilled = this.utils.checkFileFilled(data.values as FileData[]);
          } else if (data.component.config?.inputType === InputType.COLOR_PICKER) {
            isFilled = this.utils.checkColorPickerFilled(data.values as ColorPicker[], data.component.config?.hasColorText!, minQuantity!);
          } else {
            isFilled = this.utils.checkInputOrSelectFilled(data.values as string[], minQuantity!);
          }
          break;
        case ComponentType.SELECT:
          isFilled = this.utils.checkInputOrSelectFilled(data.values as string[], 1);
          break;
        case ComponentType.SCHEDULE:
          isFilled = this.utils.checkScheduleFilled(data.values as Schedule[]);
          break;
        case ComponentType.ADDRESS:
          isFilled = this.utils.checkAddressFilled(data.values as ContentAddress[]);
          break;
        case ComponentType.INTITULE:
          isFilled = this.utils.checkIntituleFilled(data.values as ContentIntitule[]);
          break;
        case ComponentType.URL:
          var urlTypes = this.refBusinessLists.urlTypes ?? [];
          isFilled = this.utils.checkUrlsWellFilled(data.values as ContentUrl[], urlTypes);
          break;
        case ComponentType.VISUAL_PUBLICATION:
          isFilled = this.utils.checkVisualPublicationFilled(data.values as FileData[]);
          break;
        case ComponentType.ACTIVITY_PRESTATIONS:
          isFilled = this.utils.checkActivityPrestationsFilled(data.values as ContentActivityPrestations[]);
          break;
        default:
          isFilled = true;
      }

      return isFilled;
    });
  }


  handleCustomerPageDatasChange(updatedCustomersData: CustomerPageData[]) {
    this.customerPageDatas = updatedCustomersData;
    var stats = this.customerPage.completionPercent;
    var pageCustomer = this.customer.pages?.find(x => x.id == this.customerPage.id);

    setTimeout(() => {
      if (stats !== null && stats !== undefined) {
        this.customerPage.completionPercent = this.calculateKeyIndicatorWeight();
        if(pageCustomer){
          pageCustomer.completionPercent = this.customerPage.completionPercent;
        }

        var blockKeyIndicator = this.calculateBlockKeyIndicator(this.currentBlockId!, this.currentBlockIteration!);
        if (this.pagesListComponent) {
          this.pagesListComponent.handlePageBlockStats(this.currentBlockId!, this.currentBlockIteration!, blockKeyIndicator);
        }
      }
    }, 0);


    //verify errors
    this.checkErrorsOnCurrentBlock();
  }

  handleAllPageBlocksStats(): void {
    if (this.customerPage && this.customerPage.blocks) {
      setTimeout(() => {
        this.customerPage.blocks!.forEach((block, i) => {
          var blockKeyIndicator = this.calculateBlockKeyIndicator(block.id, block.iteration!);
          if (this.pagesListComponent) {
            this.pagesListComponent.handlePageBlockStats(block.id, block.iteration!, blockKeyIndicator);
          }
          });
      }, 0);
    }
  }

  onFieldContainerClick(element: HTMLElement) {
    //GO TO BLOCK
    const blockId = element.dataset['blockId'];
    const blockIteration = element.dataset['blockIteration'] ? parseInt(element.dataset['blockIteration'], 10) : undefined;
    const zoom = this.utils.getRootZoom();
    const blockIndex = this.customerPage.blocks!.findIndex((block: Block) => block.id === blockId && block.iteration === blockIteration);
    this.currentStep = blockIndex;
    this.updateCurrentBlockId();

    //GO TO COMPONENT
    setTimeout(() => {
      const componentId = element.dataset['componentId'];
      const componentMultipleIteration = element.dataset['componentMultipleIteration'];

      // data-component-multiple-iteration
      const componentElement = document.querySelector(
        `.cdc-carousel-block.activeItem:not(.cdc-summary) .summary-edit-area[data-component-id="${componentId}"][data-component-multiple-iteration="${componentMultipleIteration}"]`
      ) as HTMLElement;


      if(this.isDesktop)
      {
        const containerElement = document.querySelector(`.cdc-carousel-block.activeItem:not(.cdc-summary) .slideContent`) as HTMLElement;

        if (componentElement && containerElement) {
          if (containerElement) {
            const elemOffsetTop = componentElement.getBoundingClientRect().top * zoom;
            const containerScrollTop = containerElement.getBoundingClientRect().top;

            containerElement.scrollTo({
              top: (elemOffsetTop - containerScrollTop),
              behavior: 'smooth',
            });
          }
        }
      }
      else{
        const mainContentElement = document.querySelector('.mainContent') as HTMLElement;

        if (componentElement && mainContentElement) {
          const position = componentElement.offsetTop + mainContentElement.scrollTop;

          mainContentElement.scrollTo({
            top: position,
            behavior: 'smooth',
          });
        }
      }

    }, 500);

  }

  closeAllTooltipErrorsOnCurrentBlock() {
    var blockFormComponent = this.blocksForm.find(x => x.block.id == this.currentBlockId && x.block.iteration == this.currentBlockIteration);
    if (blockFormComponent) {
      blockFormComponent.closeAllTooltipErrorsOnCurrentBlock();
    }
  }

  checkErrorsOnCurrentBlock() {
    setTimeout(() => {
      var blockFormComponent = this.blocksForm.find(x => x.block.id == this.currentBlockId && x.block.iteration == this.currentBlockIteration);
      var hasError = blockFormComponent?.tooltipData.some(tooltip => tooltip.show == true);
      if (hasError) {
        this.blockHasErrors = true;
      }
      else {
        this.blockHasErrors = false;
      }
    }, 0);
  }

  getInstructionSteps(): void {
    this.generalParameterService.getGeneralParameters('InstructionSteps')
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (param: GeneralParameter[] | GeneralParameter) => {
        if (param != null && param.values.length > 0) {
          this.instructionSteps = (param.values) as InstructionStep[];
          if (!this.customerPage.readInstructions && !this.isPreview && !this.hasFetchedInstructionSteps && this.userRole != RoleType.ADMIN && !this.isEmbed) {
            this.onOpenHelpDialog();
            this.hasFetchedInstructionSteps = true;
          }
        }
      },
      error: (error) => {
        this.instructionSteps = [];
      }
    });
  }

  onOpenHelpDialog() {
    if (this.dialogMat.openDialogs.length > 0 || this.isEmbed) {
      return;
    }

    const dialogRef = this.dialogMat.open(InstructionsModalComponent, {
      panelClass: 'instruction-modal',
      height: '80%',
      width: '90%',
      data: {
        manager: (this.customer && this.customer?.manager) ? this.customer?.manager : "",
        pageTitle: this.customerPage.type != PageType.CUSTOMER && this.customerPage.title ? this.customerPage.title : "",
        instructionSteps: this.instructionSteps
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.customerPage.readInstructions = true;
        if (!this.isPreview && this.userRole == RoleType.CUSTOMER) {
          this.customerService.updateCustomerPageInstructionStatus(this.customer.id!, this.customerPage.id!, true)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
            },
            error: (error) => {
              this.snackBar.showError(this.translationService.translate('Error saving this page'));
            }
          });
        }
      }
    });
  }

  onOpenSummaryDialog() {
    if (this.dialogMat.openDialogs.length > 0 || !this.isSubmittable) {
      return;
    }

    const headerElement = document.querySelector('.header-desktop') as HTMLElement;
    const headerReadonlyElement = document.querySelector('.header-readonly') as HTMLElement;
    const headerHeight = this.utils.getTotalHeight(headerElement);
    const headerReadonlyHeight = headerReadonlyElement ? this.utils.getTotalHeight(headerReadonlyElement) : 0;
    var headerFullHeight = headerHeight + headerReadonlyHeight + 5;

    const dialogRef = this.dialogMat.open(SummaryModalComponent, {
      autoFocus: false,
      panelClass: 'summary-modal',
      width: this.isEmbed ? '100%' : '90%',
      maxWidth: this.isEmbed ? '100%' : undefined,
      minHeight: this.isEmbed ? '100vh' : undefined,
      maxHeight: this.isDesktop ? 'calc(90vh - '+headerFullHeight+'px)' : undefined,
      data: {
        customerId: this.customer.id,
        summaryBlocks: this.summaryBlocks,
        customerPage: this.customerPage,
        userRole: this.userRole,
        customerPageDatas: this.customerPageDatas,
        isPreview: this.isPreview,
        offerStatus: this.offerStatus,
        offerHidden: this.offerHidden,
        isAllRequiredFilled: this.isAllRequiredFilled,
        blockHasErrors: this.blockHasErrors,
        refBusinessLists: this.refBusinessLists,
        fullConnectionsDefinitions: this.fullConnectionsDefinitions
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result === 'boolean') {
        if (result) {
          this.currentBlockId = null;
          this.currentBlockIteration = undefined;
          this.currentStep++;
          this.nextStep();
          this.updateGuide();
        }
      } else if (result instanceof HTMLElement) {
        this.onFieldContainerClick(result);
      }
    });
  }

  getConnectionsDefinitions() {
    this.connectionDefinitionService.getAllConnectionsDefinitions()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: ConnectionDefinition[]) => {
          this.fullConnectionsDefinitions = data;
        },
        error: (error) => {
          this.snackBar.showError(this.translationService.translate('Error fetching connections definitions'));
        }
      });
  }

  @ViewChild('sidenav') sidenav!: MatSidenav;
  sidenavToggle(){
    this.sidenav.toggle();
    const value = this.sidenav.opened;
    this.lStorage.setItem("guide_open", value);
  }

  sanitizeHtml(text: string|undefined)
  {
    return this.utils.sanitizeHtml(text);
  }

  getOriginPage(){
    if(this.customerPage?.originId){
      this.pageService.getPageDetails(this.customerPage.originId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: Page) => {
          this.originPage = data;
          this.updateGuide();
        },
        error: (error) => {
          this.snackBar.showError(this.translationService.translate('Error fetching page'));
        }
      });
    }
  }

  updateGuide(){
    if(this.isPreview){
      this.pageGuide = this.customerPage.roles?.find(x => x.name === this.userRole)?.guide;
      this.blockGuide = this.customerPage.blocks?.find(b => b.id == this.currentBlockId)?.roles?.find(x => x.name === this.userRole)?.guide;
    }
    else if(this.originPage){
      this.blockGuide = this.originPage.blocks?.find(b => b.id == this.currentBlockId)?.roles?.find(x => x.name === this.userRole)?.guide;
      this.pageGuide = this.originPage.roles?.find(x => x.name === this.userRole)?.guide;
    }

    setTimeout(() => {
      if(this.sidenav){
        var opened = this.lStorage.getItem("guide_open") ?? true;
        this.sidenav.toggle(opened);
      }
    }, 0);
  }

  //#region MOBILE
  scrollToFirstTooltipError(tooltipData: Array<TooltipPosition>){
    var firstTooltipError = tooltipData.reduce((lowest, tooltip) => {
      if (tooltip.top !== undefined && (lowest.top === undefined || tooltip.top < lowest.top)) {
        return tooltip;
      }
      return lowest;
    });

    const mainContentElement = document.querySelector('.mainContent') as HTMLElement;
    if(firstTooltipError && mainContentElement)
    {
      const fieldElement = document.querySelector(`.field-${firstTooltipError.index}`) as HTMLElement;
      if (fieldElement) {
        const mainRect = mainContentElement.getBoundingClientRect();
        const fieldRect = fieldElement.getBoundingClientRect();

        const offset = fieldRect.top - mainRect.top + mainContentElement.scrollTop;

        mainContentElement.scrollTo({
          top: offset,
          behavior: 'smooth'
        });
      }
    }
  }
  private touchStartX = 0;
  private touchEndX = 0;
  private touchStartY = 0;
  private touchEndY = 0;

  onTouchStart(event: TouchEvent | MouseEvent): void {
    if ('touches' in event) {
      // Ignore if there is more than one touch point (Ex: zoom with 2 touches at same time)
      if (event.touches.length > 1) {
        this.touchStartX = 0; // Reset
        this.touchStartY = 0; // Reset
        return;
      }
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
    } else {
      this.touchStartX = event.clientX;
      this.touchStartY = event.clientY;
    }
  }

  onTouchEnd(event: TouchEvent | MouseEvent): void {
    if ('changedTouches' in event) {
      // Ignore if there is more than one touch point (Ex: zoom with 2 touches at same time)
      if (event.changedTouches.length > 1) {
        this.touchEndX = 0; // Reset
        this.touchEndY = 0; // Reset
        return;
      }
      this.touchEndX = event.changedTouches[0].clientX;
      this.touchEndY = event.changedTouches[0].clientY;
    } else {
      this.touchEndX = event.clientX;
      this.touchEndY = event.clientY;
    }

    this.handleSwipe();
  }

  handleSwipe(): void {
    const deltaX = this.touchEndX - this.touchStartX;
    const deltaY = this.touchEndY - this.touchStartY;
    const previousBtn = document.querySelector('.cdc-button-previous') as HTMLElement;
    const nextBtn = document.querySelector('.cdc-button-next') as HTMLElement;
    if (deltaY >= -30 && deltaY <= 30) {
      if (deltaX > 50 && this.currentStep > 0) {
        if (previousBtn && this.isElementVisible(previousBtn) && !previousBtn.hasAttribute('disabled'))
          this.previousStep();
      } else if (deltaX < -50) {
        if (nextBtn && this.isElementVisible(nextBtn) && !nextBtn.hasAttribute('disabled'))
          this.nextStep();
      }
    }
  }
  isElementVisible(element: HTMLElement): boolean {
    const style = getComputedStyle(element);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      element.offsetHeight > 0 &&
      element.offsetWidth > 0
    );
  }
  scrollToTopOnMobile()
  {
    if(!this.isDesktop)
    {
      const mainContentElement = document.querySelector('.mainContent') as HTMLElement;
      if (mainContentElement) {
        mainContentElement.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    }
  }
  closeMenu(): void {
    const sidenav = document.querySelector('.customer-container mat-sidenav.sidenav') as HTMLElement;
    sidenav.classList.remove('opened');
  }
  openMenu(){
    const sidenav = document.querySelector('.customer-container mat-sidenav.sidenav') as HTMLElement;
    sidenav.classList.add('opened');

  }

  onScroll(): void {
    const mainContentElement = document.querySelector('.mainContent') as HTMLElement;
    const header = document.querySelector('.header-mobile .row-header .column-1') as HTMLElement;
    if (!mainContentElement || !header) return;

    const headerDisplay = header.style.display;
    header.style.display = mainContentElement.scrollTop === 0 ? "flex" : "none";
    if (header.style.display != headerDisplay) {
      setTimeout(() => {
        this.carouselAnimation();
      }, 0);
    }
  }

  //#endregion
  private onHtmlClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const link = target.closest('a[data-href]') as HTMLAnchorElement;

    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    const href = link.dataset['href'];
    if (!href) return;

    window.open(href, '_blank', 'noopener');
  };

  isAndroidOrWindows() {
    return this.utils.isAndroidOrWindows();
  }

  stripHtml(html: string | undefined) {
    return this.utils.stripHtml(html);
  }

  CloseButtonEmbed(): void {
    var message = {"action": "CLOSE"};
    window.parent.postMessage(message, '*');
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
    }
  }
}
